import { render, staticRenderFns } from "./NoFaceCell.vue?vue&type=template&id=180dc776&scoped=true&"
import script from "./NoFaceCell.vue?vue&type=script&lang=js&"
export * from "./NoFaceCell.vue?vue&type=script&lang=js&"
import style0 from "./NoFaceCell.vue?vue&type=style&index=0&id=180dc776&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180dc776",
  null
  
)

export default component.exports